export default {
  name: 'sa-nantucket-selectric',
  override: {
    KC_F1: 'mod',
    KC_F2: 'mod',
    KC_F3: 'mod',
    KC_F4: 'mod',
    KC_F9: 'mod',
    KC_F10: 'mod',
    KC_F11: 'mod',
    KC_F12: 'mod',
    KC_INS: 'key',
    KC_DEL: 'key',
    KC_HOME: 'key',
    KC_END: 'key',
    KC_PGUP: 'key',
    KC_PGDN: 'key',
    KC_P0: 'mod',
    KC_PDOT: 'mod'
  }
};
